(function () {

  // V2 specific selectors (matching cart-block-upsell-v2.liquid)
  const Bt_v2 = '[data-upsell-widget-v2]';
  const Zt_v2 = 'data-upsell-auto-open-v2';
  const Dt = '[data-quick-add-holder]';
  const Kt = 'data-quick-add-holder';
  const Nt = '[data-collapsible-body]';
  const V = 'is-hidden';
  const Yt = 'open';

  function extendCartItems() {
    const CartItemsClass = customElements.get('cart-items');
    if (!CartItemsClass) {
      setTimeout(extendCartItems, 100);
      return;
    }

    const proto = CartItemsClass.prototype;

    proto.refreshProductListUpsellV2 = function () {
      if (this._upsellRefreshTimerV2) clearTimeout(this._upsellRefreshTimerV2);
      this._upsellRefreshTimerV2 = setTimeout(() => this._doUpsellRefreshV2(), 1000);
    };

    proto._doUpsellRefreshV2 = function () {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;

      const now = Date.now();
      if (this._lastUpsellFetchTimeV2 && (now - this._lastUpsellFetchTimeV2) < 500) return;
      this._lastUpsellFetchTimeV2 = now;

      fetch('/?section_id=api-upsell-v2').then(t => t.text()).then(html => {
        // Clean up duplicate v2 widgets
        const allWidgets = document.querySelectorAll('[data-upsell-widget-v2]');
        for (let i = 1; i < allWidgets.length; i++) {
          const parent = allWidgets[i].closest('.cart-block');
          if (parent && parent.children.length === 1) parent.remove();
          else allWidgets[i].remove();
        }

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;

        const newUpsellWidget = tempDiv.querySelector('[data-upsell-widget-v2]');
        const currentUpsellWidget = document.querySelector('[data-upsell-widget-v2]');

        if (!newUpsellWidget) {
          if (currentUpsellWidget) currentUpsellWidget.classList.add('is-hidden');
          return;
        }

        const newProducts = newUpsellWidget.querySelector('[data-product-list-upsell-v2]');
        if (!newProducts || newProducts.children.length === 0) return;

        if (currentUpsellWidget) {
          const currentProducts = currentUpsellWidget.querySelector('[data-product-list-upsell-v2]')
            || currentUpsellWidget.querySelector('[data-upsell-products-v2]');

          if (currentProducts) {
            currentProducts.innerHTML = newProducts.innerHTML;
            currentUpsellWidget.classList.remove('is-hidden');
            return;
          }

          const currentInner = currentUpsellWidget.querySelector('.cart__widget__products--v2');
          if (currentInner) {
            currentInner.innerHTML = newProducts.innerHTML;
            currentUpsellWidget.classList.remove('is-hidden');
            return;
          }
        } else {
          const cartBody = cartDrawer.querySelector('[data-cart-drawer-body]');
          const checkoutButtons = cartDrawer.querySelector('[data-checkout-buttons]');

          if (cartBody) {
            const wrapper = document.createElement('div');
            wrapper.className = 'cart-block';
            wrapper.appendChild(newUpsellWidget);

            if (checkoutButtons) checkoutButtons.parentNode.insertBefore(wrapper, checkoutButtons);
            else cartBody.appendChild(wrapper);

            // V2 uses .cart__widget__heading selector (no SVG manipulation)
            const summary = newUpsellWidget.querySelector('summary.cart__widget__title--v2');
            if (summary) {
              const heading = summary.querySelector('.cart__widget__heading');
              if (heading && !heading.textContent.trim()) {
                heading.textContent = 'Vervollständige deinen Look';
              }
            }

            newUpsellWidget.setAttribute('open', 'true');
            const body = newUpsellWidget.querySelector('[data-collapsible-body]');
            if (body) { body.style.height = 'auto'; body.style.overflow = 'visible'; }
            const content = newUpsellWidget.querySelector('.cart__widget__content--v2');
            if (content) content.style.height = 'auto';

            if (summary) {
              summary.addEventListener('click', (e) => {
                e.preventDefault();
                const isOpen = newUpsellWidget.hasAttribute('open');
                if (isOpen) {
                  newUpsellWidget.removeAttribute('open');
                  if (body) body.style.height = '';
                  if (content) content.style.height = '';
                } else {
                  newUpsellWidget.setAttribute('open', 'true');
                  if (body) { body.style.height = 'auto'; body.style.overflow = 'visible'; }
                  if (content) content.style.height = 'auto';
                }
              });
            }
          }
        }
      }).catch(() => {});
    };

    proto.saveLastUpsellTypeV2 = function (productType) {
      if (!productType) return;
      fetch('/cart.js').then(r => r.json()).then(cart => {
        const newCounter = parseInt(cart.attributes._upsell_counter || '0', 10) + 1;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { '_upsell_counter': String(newCounter) } })
        }).catch(() => {});
      }).catch(() => {});
    };

    proto.skipUpsellProductEventV2 = function () {
      const holder = document.querySelector('[data-upsell-products-v2]');
      if (!holder) return;
      const t = holder.querySelectorAll('[data-skip-upsell-product]');
      t.length && t.forEach((t => {
        t.addEventListener("click", (e => {
          e.preventDefault();
          const s = t.closest(Dt).getAttribute(Kt);
          this.skipUpsellProductsArray.includes(s) || this.skipUpsellProductsArray.push(s);
          window.sessionStorage.setItem("skip_upsell_products_v2", this.skipUpsellProductsArray);
          this.removeUpsellProductV2(s);
          this.toggleCartUpsellWidgetVisibilityV2();
        }));
      }));
    };

    proto.checkSkippedUpsellProductsFromStorageV2 = function () {
      const t = window.sessionStorage.getItem("skip_upsell_products_v2");
      if (!t) return;
      t.split(",").forEach((t => {
        this.skipUpsellProductsArray.includes(t) || this.skipUpsellProductsArray.push(t);
        this.removeUpsellProductV2(t);
      }));
    };

    proto.removeUpsellProductV2 = function (t) {
      const holder = document.querySelector('[data-upsell-products-v2]');
      if (!holder) return;
      const e = holder.querySelector(`[${Kt}="${t}"]`);
      e && e.parentNode.remove();
    };

    proto.toggleCartUpsellWidgetVisibilityV2 = function () {
      const holder = document.querySelector('[data-upsell-products-v2]');
      if (!holder) return;
      const t = holder.querySelectorAll(Dt);
      const e = holder.closest(Bt_v2);
      if (e && (e.classList.toggle(V, !t.length), t.length && !e.hasAttribute(Yt) && e.hasAttribute(Zt_v2))) {
        e.setAttribute(Yt, !0);
        const t = e.querySelector(Nt);
        t && (t.style.height = "auto");
      }
    };

// V2 turning on upsell 

document.addEventListener('theme:cart:change', () => {
    const v2Widget = document.querySelector('[data-upsell-widget-v2]');
    if (v2Widget && window.getComputedStyle(v2Widget).display === 'none') return;
    const cartItemsEl = document.querySelector('cart-items');
    if (cartItemsEl && cartItemsEl.refreshProductListUpsellV2) {
        cartItemsEl.refreshProductListUpsellV2();
    }
});

  // V2 upsell type rotation
  document.addEventListener("click", function (e) {
    const quickAdd = e.target.closest('quick-add-product');
    if (!quickAdd) return;
    const upsellContainer = quickAdd.closest('[data-product-list-upsell-v2]');
    if (!upsellContainer) return;
    const isAddButton = e.target.closest('[data-add-to-cart]') || e.target.closest('[data-quick-add-modal-handle]') || e.target.closest('[data-quick-add-btn]');
    if (!isAddButton) return;
    const productType = quickAdd.getAttribute('data-product-type');
    const cartItemsEl = document.querySelector('cart-items');
    if (cartItemsEl && cartItemsEl.saveLastUpsellTypeV2) cartItemsEl.saveLastUpsellTypeV2(productType);
  }, true);

document.addEventListener('theme:cart:change', () => {
      const v2Widget = document.querySelector('[data-upsell-widget-v2]');
      if (v2Widget && window.getComputedStyle(v2Widget).display === 'none') return;
      const cartItemsEl = document.querySelector('cart-items');
      if (cartItemsEl && cartItemsEl.refreshProductListUpsellV2) {
        cartItemsEl.refreshProductListUpsellV2();
      }
    });

    document.addEventListener("click", function (e) {
      const quickAdd = e.target.closest('quick-add-product');
      if (!quickAdd) return;
      const upsellContainer = quickAdd.closest('[data-product-list-upsell-v2]');
      if (!upsellContainer) return;
      const isAddButton = e.target.closest('[data-add-to-cart]') || e.target.closest('[data-quick-add-modal-handle]') || e.target.closest('[data-quick-add-btn]');
      if (!isAddButton) return;
      const productType = quickAdd.getAttribute('data-product-type');
      const cartItemsEl = document.querySelector('cart-items');
      if (cartItemsEl && cartItemsEl.saveLastUpsellTypeV2) cartItemsEl.saveLastUpsellTypeV2(productType);
    }, true);
  }

  extendCartItems();

})();